<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import {Netty} from "@/utils/netty";
import Lockscreen from "@/components/lockscreen/lockscreen"
import {debounce} from "@/utils/utils";

export default {
  name: 'App',
  components: {
    's-lock-screen': Lockscreen,
  },
  data() {
    return {
      keyboardShow: false,
      lockShow: false,
      timer: null,
    }
  },
  mounted() {

    // const netty = new Netty();
    // netty.init()

    // this.keepTime()
    // document.addEventListener('mousedown', debounce(this.touchActivated, 400))
    // document.addEventListener('touchStart', debounce(this.touchActivated, 400))
    // document.addEventListener("focus", (e) => {
    //   const element = e.target
    //   const textAtt = element.getAttribute("type")
    //   const readonlyAtt = element.getAttribute("readonly")
    //   // console.log(element,textAtt)
    //   if (element.tagName === "INPUT" && ['text', 'password', 'number'].includes(textAtt) && readonlyAtt != 'readonly') {
    //     // console.log('input获取了焦点')
    //     this.keyboardShow = true
    //   }
    // }, true)
    // document.addEventListener("blur", (e) => {
    //   const element = e.target
    //   const textAtt = element.getAttribute("type")
    //   const readonlyAtt = element.getAttribute("readonly")
    //   if (element.tagName === "INPUT" && ['text', 'password', 'number'].includes(textAtt) && readonlyAtt != 'readonly') {
    //     // console.log('input失去了焦点')
    //     this.keyboardShow = false
    //   }
    // }, true)

    /*Cookies.set('sidebarStatus', 0)
    const netty = new Netty();
    netty.init()*/
  },

  methods: {
    // touchActivated() {
    //   this.lockShow = false
    //
    //   this.keepTime()
    // },
    //
    // keepTime() {
    //   clearTimeout(this.timer)
    //   this.timer = setTimeout(() => {
    //     this.lockShow = true
    //   }, 900000)
    // }
  },
}

</script>
<style lang="scss" scoped>
  .banner-leave-active,
  .banner-enter-active {
    transition: opacity .5s;
  }

  .banner-leave-to,
  .banner-enter {
    opacity: 0;
  }

  .banner-enter-to {
    opacity: 1;
  }
</style>
